import React from "react";
import Card from "@amzn/meridian/card";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import Icon from "@amzn/meridian/icon";
import chevronRightSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-right-small";
import { InspectionListView } from "src/services/inspectionService";
import { formatDate } from "src/utils/dateUtil";

type HistoryInspectionCardProps = {
  inspection: InspectionListView;
  onClick: (inspection: InspectionListView) => void;
};

/**
 * A single Inspection History card: the submission timestamp on top (completedAt,
 * falling back to createdAt for completed inspections persisted before completedAt
 * existed) and the compliance outcome below — green "Compliant" when every scored
 * question passed, red "Non Compliant" otherwise.
 */
const HistoryInspectionCard = ({ inspection, onClick }: HistoryInspectionCardProps) => {
  const { compliantCount, questionCount } = inspection.complianceStats;
  const isCompliant = compliantCount >= questionCount;
  const { datePart, timePart } = formatDate(inspection.completedAt ?? inspection.createdAt);

  return (
    <Card onClick={() => onClick(inspection)} spacingInset="400">
      <Row alignmentHorizontal="justify" alignmentVertical="center" spacing="300">
        <Column spacing="200">
          <Row spacing="200" alignmentVertical="center" wrap="down">
            <Text type="b200" color="primary">
              <b>{datePart},</b>
            </Text>
            <Text type="b200" color="secondary">
              {timePart}
            </Text>
          </Row>
          {isCompliant ? (
            <Text type="h300" color="success">
              Compliant
            </Text>
          ) : (
            <Text type="h300" color="error">
              Non Compliant
            </Text>
          )}
        </Column>
        <Icon tokens={chevronRightSmallTokens} color="primary" />
      </Row>
    </Card>
  );
};

export default HistoryInspectionCard;
